import Tippy from "@tippy.js/react";

type Props = {
  content: React.ReactNode;
  children: React.ReactNode;
};

export function Tooltip({ content, children }: Props) {
  return (
    // @ts-expect-error TS(2322) FIXME: Type 'ReactNode' is not assignable to type 'ReactC... Remove this comment to see the full error message
    <Tippy className="tool-tip" placement="right" content={content}>
      {/* @ts-expect-error TS(2322) FIXME: Type 'ReactNode' is not assignable to type 'ReactE... Remove this comment to see the full error message */}
      {children}
    </Tippy>
  );
}

export default Tooltip;
